import api from './client'

export interface Goal {
  id: number
  surface_goal: string
  underlying_need: string | null
  status: 'active' | 'completed' | 'abandoned'
  progress: number
  created_at: string
  updated_at: string
}

interface GoalListResponse {
  goals: Goal[]
  total: number
}

interface GoalCreate {
  surface_goal: string
  underlying_need?: string
}

interface GoalUpdate {
  progress?: number
  note?: string
  status?: 'active' | 'completed' | 'abandoned'
}

export async function getGoals(activeOnly = true): Promise<GoalListResponse> {
  const response = await api.get<GoalListResponse>(
    `/user/goals?active_only=${activeOnly}`
  )
  return response.data
}

export async function createGoal(data: GoalCreate): Promise<Goal> {
  const response = await api.post<Goal>('/user/goals', data)
  return response.data
}

export async function updateGoal(goalId: number, data: GoalUpdate): Promise<Goal> {
  const response = await api.patch<Goal>(`/user/goals/${goalId}`, data)
  return response.data
}

export async function deleteGoal(goalId: number): Promise<void> {
  await api.delete(`/user/goals/${goalId}`)
}
